import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Button, CustomInput } from "../CustomComponents";
import cssStyles from "./styles/editModal.module.scss";
import ModalContainer from "../ModalContainer";
import { FaCircleXmark } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import { IoEyeOff } from "react-icons/io5";
import LoadingButton from "../CustomComponents/LoadingButton";

const ChangePasswordModal = ({ handleModalClose, onSubmit, isLoading }) => {
  const { handleSubmit, control, register, errors } = useForm({
    mode: "onChange",
  });
  const [type, setType] = useState(false);

  return (
    <>
      <div className="">
        <ModalContainer handleClose={handleModalClose}>
          <div className={cssStyles.modalContainer}>
            <div className="d-flex align-items-center w-100 justify-content-between">
              <p className="fs-4 fw-medium m-0">Change Password</p>
              <span className="bg-opacity-75 d-flex p-3 rounded-5">
                <FaCircleXmark
                  size={25}
                  role="button"
                  onClick={handleModalClose}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)} className="w-100">
              <div className="" style={{ position: "relative" }}>
                <Controller
                  control={control}
                  name="new_password"
                  rules={{
                    required: {
                      value: true,
                      message: "required",
                    },
                    pattern: {
                      value:
                        /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/,
                      message:
                        "Password must be at least 8 characters long and include at least one letter and one number",
                    },
                  }}
                  render={({
                    field: { onChange, onBlur, value, ref },
                    fieldState: { error },
                  }) => (
                    <>
                      <CustomInput
                        placeholder="Confirm Password"
                        type={type ? "text" : "password"}
                        onChange={onChange}
                        maxLength={20}
                      />
                      {error && (
                        <span className={cssStyles.validationtxt}>
                          {error?.message}
                        </span>
                      )}
                    </>
                  )}
                />
                {type ? (
                  <IoEyeOff
                    style={{ position: "absolute", top: "15px", right: "15px" }}
                    onClick={() => setType(!type)}
                  />
                ) : (
                  <FaEye
                    style={{ position: "absolute", top: "15px", right: "15px" }}
                    onClick={() => setType(!type)}
                  />
                )}
              </div>
              <Controller
                control={control}
                name="confirmPassword"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <CustomInput
                    placeholder="Confirm Password"
                    type="password"
                    onChange={onChange}
                    maxLength={20}
                  />
                )}
              />
              <div className={cssStyles.saveButton}>
                <Button
                  text={isLoading ? <LoadingButton /> : "Change Password"}
                  classes="fs-6 mb-2 mt-3 mt-auto"
                  type="submit"
                  disabled={isLoading}
                />
              </div>
            </Form>
          </div>
        </ModalContainer>
      </div>
    </>
  );
};

export default ChangePasswordModal;
